import * as _ from "lodash";

import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { compose, lifecycle, pure } from "recompose";

import CategoryCell from "./CategoryCell";
import { FormattedMessage } from "react-intl";
import ListAutoScroll from "../../../elements/List/ListAutoScroll";
import PropTypes from "prop-types";
import Queries from "../../../queries/queries2";
import React from "react";
import ShortenedText from "../../../elements/Text/ShortenedText";
import Spinner from "../../../elements/Spinner/Spinner";
import Table from "../../../elements/Table/Table";
import computeCategoryCellText from "../PaymentList/computeCategoryCellText";
import { fixDateFromDataBase } from "../../../tools/formatDate";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import moment from "moment";
import { injectIntl } from "react-intl";
import isMissingExpenseOrInvoice from "../PaymentList/isMissingExpenseOrInvoice";
import { withRouter } from "react-router-dom";

// import CurrencySpan from '../../Currency/CurrencySpan';

// import Spinner from "../../../elements/Spinner/Spinner";

// import { defineMessages } from "react-intl";

// import moment from 'moment';

const textSearch = term => {
  return {
    OR: [{ libelleLong_contains: term }]
  };
};

// const BANK_TRANSACTION_QUALIFIED_SUBSCRIPTION = gql`
//   subscription onBankTransactionQualified(
//     $companyId: ID!
//     $bankAccountId: ID!
//   ) {
//     bankTransactionQualified(
//       companyId: $companyId
//       bankAccountId: $bankAccountId
//     ) {
//       id
//       status
//       bankTransactionLines(orderBy: numLine_ASC) {
//         id
//         category {
//           id
//         }
//         tiers {
//           id
//         }
//       }
//     }
//   }
// `;

const BANK_TRANSACTION_CREATED_SUBSCRIPTION = gql`
  subscription onBankTransactionCreated($companyId: ID!, $bankAccountId: ID!) {
    bankTransactionCreated(
      companyId: $companyId
      bankAccountId: $bankAccountId
    ) {
      id
      status
      bankTransactionLines(orderBy: numLine_ASC) {
        id
        category {
          id
        }
        tiers {
          id
        }
      }
      ecritureLines {
        id
        labelLettrage
      }
      attachment {
        id
      }
      isDeleted
    }
  }
`;

const BANK_TRANSACTION_UPDATED_SUBSCRIPTION = gql`
  subscription onBankTransactionUpdated($companyId: ID!, $bankAccountId: ID!) {
    bankTransactionUpdated(
      companyId: $companyId
      bankAccountId: $bankAccountId
    ) {
      id
      status
      bankTransactionLines(orderBy: numLine_ASC) {
        id
        category {
          id
        }
        tiers {
          id
        }
      }
      ecritureLines {
        id
        labelLettrage
      }
      attachment {
        id
      }
      isDeleted
    }
  }
`;

let doneArray = [];
const data = graphql(Queries.GET_ALL_BANK_TRANSACTIONS, {
  options: ({ bankAccountId, tabSelected, dateRange, searchTerm, tiersId, companyId }) => {
    let filter = { isDeleted: false };
    if (dateRange.from) {
      filter["date_gte"] = dateRange.from;
    }
    if (dateRange.to) {
      filter["date_lte"] = dateRange.to;
    }
    if (searchTerm) {
      filter = Object.assign(filter, textSearch(searchTerm));
    }
    if (tabSelected.name === "toQualify") {
      filter["status"] = "AQUALIFIER";
    }
    if (tabSelected.name === "toDo") {
      filter["status_in"] = ["AQUALIFIER", "QUALIFIE_AUTO"];
    }
    if (tabSelected.name === "toJustify") {
      filter.ecritureLines_some = {
        AND: [
          {
            labelLettrage: "",
            OR: [
              { advancePayment: false },
              { advancePayment: null }
            ]
          },
          {
            category: {
              categoryFamily: {
                OR: [
                  { supplierCategoryForEcriture: true },
                  { clientCategoryForEcriture: true },
                  { collaboratorCategoryForEcriture: true },
                ]
              }
            }
          }
        ]
      }
    }

    if (tiersId) filter.bankTransactionLines_some = { tiers: { id: tiersId } };

    // console.log("165 - GET_ALL_BANK_TRANSACTIONS...");
    // doneArray = [];
    return {
      fetchPolicy: "cache-and-network",
      variables: {
        companyId,
        skip: 0,
        first: 1000,
        bankAccountId,
        filter
      }
    };
  },
  props: ({ data }) => ({
    data,
    loadMorePayments: nextPage => {
      console.log("179 - nextPage Payments", nextPage, data.getAllBankTransactions.length || 0);
      return data.fetchMore({
        variables: {
          skip: data.getAllBankTransactions.length || 0,
          first: 1000
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) {
            return previousResult;
          }

          if (
            previousResult._bankTransactionsMeta &&
            previousResult.getAllBankTransactions &&
            previousResult.getAllBankTransactions.length >= previousResult._bankTransactionsMeta.count
          ) {
            console.log("199 - full=", previousResult._bankTransactionsMeta.count);
            return previousResult;
          }

          const first = fetchMoreResult.getAllBankTransactions[0] &&
            fetchMoreResult.getAllBankTransactions[0].id || null;

          if (first) {
            if (doneArray.includes(first)) {
              console.log("199 - already=", first, doneArray);
              return previousResult;
            }
            doneArray.push(first);
          }

          return Object.assign({}, previousResult, {
            getAllBankTransactions: [
              ...previousResult.getAllBankTransactions,
              ...fetchMoreResult.getAllBankTransactions
            ]
          });
        }
      });
    }
  })
});

// const componentLifecycle = lifecycle({
//   componentDidMount() {
//     console.log("PaymentList.componentDidMount", this.props);
//     if (!this.props.data) return;

//     this.unsubscribe = this.props.data.subscribeToMore({
//       document: BANK_TRANSACTION_QUALIFIED_SUBSCRIPTION,
//       variables: {
//         companyId: this.props.companyId,
//         bankAccountId: this.props.bankAccountId
//       },

//       updateQuery: (prev, { subscriptionData }) => {
//         console.log(
//           "PaymentList.BANK_TRANSACTION_QUALIFIED_SUBSCRIPTION",
//           subscriptionData
//         );
//         // if (!subscriptionData.data) {
//         //   return prev;
//         // }
//         return prev;
//       }
//     });

//     // const LETTRAGE_DONE = gql`
//     //   subscription onLettrageDone {
//     //     _bankTransactionsMeta {
//     //       bankAccountId
//     //       #count
//     //     }
//     //   }
//     // `;

//     // this.props.data.subscribeToMore({
//     //   document: LETTRAGE_DONE,
//     //   refetchQueries: [
//     //     {
//     //       query: Queries.GET_ALL_BANK_TRANSACTIONS
//     //     },
//     //     {
//     //       query: Queries.GET_CLIENT_CONNECTION
//     //     },
//     //     {
//     //       query: Queries.GET_COLLABORATOR_CONNECTION
//     //     },
//     //     {
//     //       query: Queries.GET_SUPPLIER_CONNECTION
//     //     }
//     //   ],

//     //   updateQuery: (prev, { subscriptionData }) => {
//     //     console.log("subscriptionData(1)", subscriptionData);
//     //     //this.props.data.refetch();

//     //     if (!subscriptionData.data) {
//     //       return prev;
//     //     }
//     //     return subscriptionData.data;
//     //   }
//     // });

//     console.log("subscribeToMore");
//     return;
//   },

//   componentWillUnmount() {
//     this.unsubscribe();
//   }
// });

const componentLifecycle = lifecycle({
  componentDidMount() {
    // console.log("248 - BankAccountSelectElement.componentDidMount", this);
    if (!this.props.data) // || (this.props.data && this.props.data.loading))
      return;

    // BankTransactionCreated
    this.unsubscribeBankTransactionCreated = this.props.data.subscribeToMore({
      document: BANK_TRANSACTION_CREATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId,
        bankAccountId: this.props.bankAccountId
      },

      updateQuery: (prev, { subscriptionData }) => {
        // console.log("284 - refecth...");
        this.props.data.refetch();
        return prev;
      }
    });

    // BankTransactionUpdated
    this.unsubscribeBankTransactionUpdated = this.props.data.subscribeToMore({
      document: BANK_TRANSACTION_UPDATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId,
        bankAccountId: this.props.bankAccountId
      },

      updateQuery: (prev, { subscriptionData }) => {
        // console.log("299 - prev", prev, subscriptionData);

        if (!prev.getAllBankTransactions || !prev._bankTransactionsMeta) {
          // console.log("276 - refecth...");
          this.props.data.refetch();
        }
        return prev;
      }
    });
    return;
  },

  componentWillUnmount() {
    if (this.unsubscribeBankTransactionCreated)
      this.unsubscribeBankTransactionCreated();

    if (this.unsubscribeBankTransactionUpdated)
      this.unsubscribeBankTransactionUpdated();
  }
});

const toolTipMissingExpense = (
  <Tooltip id="tooltip">
    <p>
      <FormattedMessage id="ids_missingExpense_text" />
    </p>
  </Tooltip>
);

const toolTipMissingInvoice = (
  <Tooltip id="tooltip">
    <p>
      <FormattedMessage id="ids_missingInvoice_text" />
    </p>
  </Tooltip>
);

// function isMissingExpense(ecritureLines) {
//   for (const ecritureLine of ecritureLines) {
//     if (ecritureLine.labelLettrage === "" && ecritureLine.category &&
//       (
//         ecritureLine.category.categoryFamily.supplierCategoryForEcriture === true ||
//         ecritureLine.category.categoryFamily.clientCategoryForEcriture === true ||
//         ecritureLine.category.categoryFamily.collaboratorCategoryForEcriture === true
//       )
//     ) {
//       if ( ecritureLine.tiers)
//         return ecritureLine.tiers.name;
//       // console.log("337 - ecritureLine=", ecritureLine);
//       // return true;
//       return "";
//     }
//   }
//   return "";
// }

// function isMissingInvoice(ecritureLines) {
//   for (const ecritureLine of ecritureLines) {
//     if (ecritureLine.labelLettrage === "" && ecritureLine.category &&
//       (
//         ecritureLine.category.categoryFamily.clientCategoryForEcriture === true ||
//         ecritureLine.category.categoryFamily.collaboratorCategoryForEcriture === true
//       )) {
//       return true;
//     }
//   }
//   return false;
// }

async function goToInvoiceExpense(
  row,
  missingExpenseTiers,
  companyDefaultInfos,
  currency,
  history,
  exchangeRateForTiers
) {

  const variables = {
    date: new Date(row.original.date),
    currencyId: currency.id,
    companyCurrencyId: (missingExpenseTiers &&
      missingExpenseTiers.tiers &&
      missingExpenseTiers.tiers.currency.id) || companyDefaultInfos.company.currency.id
  };

  exchangeRateForTiers.variables = variables;
  let exchangeRateTmp = await exchangeRateForTiers.refetch(variables);
  // console.log("374 - exchangeRateTmp=", exchangeRateTmp);

  let exchangeRate = 1.0;
  if (
    exchangeRateTmp &&
    exchangeRateTmp.data &&
    exchangeRateTmp.data.getExchangeRate
  )
    exchangeRate = exchangeRateTmp.data.getExchangeRate.value;

  history.push({
    pathname: (
      (missingExpenseTiers.category &&
        missingExpenseTiers.category.categoryFamily.ids === "ids_clients")
        ? "/invoices/new"
        : "/expenses/new"),
    state: {
      tiersId: missingExpenseTiers.tiers.id,
      tiers: missingExpenseTiers.tiers,
      // amount: Math.abs(row.original.amount * exchangeRate), // Math.abs(missingExpenseTiers.amount),
      amount: (-1) * (row.original.amount * exchangeRate), // Math.abs(missingExpenseTiers.amount),
      currency: (missingExpenseTiers.tiers.currency || currency),
      defaultTermNetsFinDeMois: missingExpenseTiers.tiers.client &&
        missingExpenseTiers.tiers.client.defaultTermNetsFinDeMois,
      defaultTermDelaisPaiement: missingExpenseTiers.tiers.client &&
        missingExpenseTiers.tiers.client.defaultTermDelaisPaiement,
    }
  });

  return
}

let PaymentList = ({
  data,
  history,
  intl,
  loadMorePayments,
  tabSelected,
  onRowSelect,
  currency,
  updateBankTransaction,
  confirmBankTransaction,
  validateAllBankTransactions,
  locale,
  companyDefaultInfos,
  exchangeRateForTiers,
  loading,
  setLoading,
  refreshInProgress,
  setRefreshInProgress,
}) => {

  let bankTransactions = [];
  let dataLength = 0;
  let dataMaxLength = 0;

  if (!data.getAllBankTransactions || loading) {
    // console.log("439 - spinner....");
    return <Spinner size="lg" fullScreen />;
  }

  bankTransactions = data.getAllBankTransactions;
  dataLength = bankTransactions && bankTransactions.length;
  dataMaxLength =
    (data._bankTransactionsMeta && data._bankTransactionsMeta.count) || 0;

  // TRANSLATIONS...
  _.forEach(bankTransactions, bt => {
    if (bt && bt.bankTransactionLines) {
      _.forEach(bt.bankTransactionLines, line => {
        if (line && line.category && line.category.ids !== null) {
          line.category.name = intl.formatMessage({ id: line.category.ids });
        }
      });
    }
  });

  // console.log("458 - dataLength=", dataLength, dataMaxLength, data.loading);

  // console.log('data:', this.state.ecritureLines);
  let showValidateAll = false;
  for (const bankTransaction of bankTransactions) {
    bankTransaction.fixedDate = new Date(
      fixDateFromDataBase(bankTransaction.date)
    );

    if (bankTransaction.status === "QUALIFIE_AUTO") showValidateAll = true;
  }

  setLoading(dataLength < dataMaxLength || data.loading);

  if (dataLength === dataMaxLength && !data.loading) {
    // console.log("491 - clean doneArray=", doneArray);
    doneArray = [];
  }

  if (refreshInProgress === true && data.loading === false) {
    setRefreshInProgress(false);
  }

  if (refreshInProgress === true) {
    // console.log("512 - refreshInProgress...");
    // return <Spinner size="lg" fullScreen />; 
  }

  return (
    <div>
      <ListAutoScroll
        identifier={tabSelected}
        dataLength={data.getAllBankTransactions.length}
        dataMaxLength={data._bankTransactionsMeta && data._bankTransactionsMeta.count}
        loadMore={loadMorePayments}
      >
        {/* {!data.getAllBankTransactions && <Spinner size="lg" fullScreen />} */}
        {/* {!data.loading && ( */}
        <React.Fragment>
          {showValidateAll && (
            <Button
              className="btn-fill pull-right margin-left-20"
              bsStyle="primary"
              onClick={() =>
                validateAllBankTransactions(
                  bankTransactions && bankTransactions[0] &&
                  bankTransactions[0].bankAccount &&
                  bankTransactions[0].bankAccount.id
                )
              }
            >
              <i className="fa fa-lg fa-check-circle margin-right-5" />
              <FormattedMessage id="ids_validateAll" />
            </Button>
          )}
          <Table
            dataSelectedCount={["amount"]}
            tableName="payments"
            visibleColumns={[
              // {
              //   name: "compte",
              //   type: "string",
              //   accessor: "bankAccount.name"
              // },
              {
                name: "date",
                type: "date",
                accessor: "fixedDate"
              },
              // { name: "payment", type: "string", maxWidth: "100" },
              {
                name: "libelle",
                maxWidth: "600",
                accessor: "libelleCourt",
                Cell: row => {
                  //console.log("libelle cell", row);
                  return (
                    <ShortenedText
                      shortText={row.value}
                      longText={(row.value.length < row.original.libelleLong.length) ? row.original.libelleLong : row.value}
                    />
                  );
                },
                export: row => {
                  // console.log("libelle cell", row);
                  if (row.libelleLong === row.libelleCourt || (row.libelleLong.length < row.libelleCourt.length))
                    return row.libelleCourt;
                  else
                    return (row.libelleCourt + " (" + row.libelleLong + ")");
                },
              },
              {
                name: "amount",
                type: "currency",
                currency: currency,
                colored: true
              },
              {
                name: "category",
                maxWidth: "300",
                accessor: "status",
                filterable: false,
                export: row => {
                  const tmp = computeCategoryCellText(
                    row.bankTransactionLines,
                    row.ecritureLines,
                    row.status,
                    intl,
                    history
                  );
                  return tmp.text;
                },
                Cell: row => {
                  const lines = row.original.bankTransactionLines;
                  const ecritureLines = row.original.ecritureLines;
                  const id = row.original.id;
                  return (
                    <CategoryCell
                      status={row.value}
                      bankTransactionLines={lines}
                      ecritureLines={ecritureLines}
                      history={history}
                      qualifyPayment={() =>
                        //updateBankTransaction({ id, status: "QUALIFIE" })
                        confirmBankTransaction({ id })
                      }
                    />
                  );
                }
              },
              {
                name: "piece",
                accessor: "attachment.id",
                maxWidth: 70,
                export: d => (d.attachment ? "oui" : ""),
                Cell: row => {
                  let ret = "";
                  let missingExpense = "";
                  let missingInvoice = "";

                  // const missingExpenseBool = isMissingExpense(row.original.ecritureLines);
                  const missingExpenseTiers = isMissingExpenseOrInvoice(
                    row.original.ecritureLines
                  );
                  // const missingInvoiceBool = isMissingInvoice(row.original.ecritureLines);                   

                  if (missingExpenseTiers &&
                    missingExpenseTiers.tiers &&
                    missingExpenseTiers.tiers.name !== ""
                  ) {

                    missingExpense = (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          // row && row.original && row.original.amount > 0
                          missingExpenseTiers.category && missingExpenseTiers.category.categoryFamily.ids === "ids_clients"
                            ? toolTipMissingInvoice
                            : toolTipMissingExpense
                        }
                      >
                        <i
                          onClick={e => {
                            if (
                              row &&
                              row.original &&
                              row.original.ecritureLines &&
                              row.original.ecritureLines.length === 2
                            ) {
                              e.stopPropagation();

                              goToInvoiceExpense(
                                row,
                                missingExpenseTiers,
                                companyDefaultInfos,
                                currency,
                                history,
                                exchangeRateForTiers
                              );
                            }
                          }}
                          className={
                            // row && row.original && row.original.amount > 0
                            (missingExpenseTiers.category && missingExpenseTiers.category.categoryFamily.ids === "ids_clients")
                              ? "fa text-danger fa-lg fa-file-text"
                              : "fa text-danger fa-lg fa-shopping-cart"
                          }
                        />
                      </OverlayTrigger>
                    );
                  }

                  // if (missingInvoiceBool === true) {
                  //   missingInvoice = <OverlayTrigger placement="top" overlay={toolTipMissingInvoice}>
                  //     <i
                  //       onClick={e => {
                  //         e.stopPropagation();
                  //         console.log("CLICK...");
                  //         history.push("/invoices/new");
                  //       }}
                  //       className="fa text-danger fa-lg fa-file-text-o" />
                  //   </OverlayTrigger>;
                  // }

                  if (row.value) {
                    ret = <i className="fa fa-lg fa-paperclip" />;
                  }
                  return (
                    <div>
                      {ret} {missingExpense} {missingInvoice}
                    </div>
                  );
                }
              },
              {
                id: "year",
                visible: false,
                name: "year",
                type: "string",
                accessor: d => {
                  return moment(d.fixedDate).format("YYYY");
                },
                export: d => {
                  return moment(d.fixedDate).format("YYYY");
                }
              },
              {
                id: "month",
                visible: false,
                name: "month",
                type: "string",
                accessor: d => {
                  return moment(d.fixedDate).format("MM");
                },
                export: d => {
                  return moment(d.fixedDate).format("MM");
                }
              },
            ]}
            locale={locale}
            data={bankTransactions}
            onRowClick={(id, state, rowInfo, column, instance) => {
              history.push(`/payments/${id}/affectation`);
            }}
            //onRowClick={id => (data.bankAccount.dateCloture === null || data.bankAccount.dateCloture === undefined)?
            //  history.push(`/payments/${id}/affectation`):
            //  console.log("SKIP:", id, data.bankAccount.dateCloture)}
            onImport={data => console.log("import", data)}
            onRowSelect={onRowSelect}
            printable
            exportable
            defaultSorted={[
              {
                id: "fixedDate",
                desc: true
              },
              {
                id: "amount",
                desc: false
              }
            ]}
          />
        </React.Fragment>
        {/* )} */}
      </ListAutoScroll>
    </div>
  );
};

PaymentList.propTypes = {
  handleFilter: PropTypes.func,
  currency: PropTypes.object
};

PaymentList = compose(
  data,
  pure,
  componentLifecycle
)(PaymentList);

export default withRouter(injectIntl(PaymentList));
